var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-sm-flex align-items-center justify-content-between mb-4"},[_c('h1',{staticClass:"h3 mb-0 text-gray-800"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }